import { Chip } from "@heroui/react"

import { ChevronRightIcon } from "@heroicons/react/20/solid"

import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  QuestionMarkCircleIcon,
  XCircleIcon,
} from "@heroicons/react/24/outline"

import classNames from "classnames"
import PropTypes from "prop-types"

const CheckListItem = ({ 
  handleClick = null,
  icon,
  meta = null, 
  required = false, 
  status, 
  title
}) => (
  <div className={classNames({"flex items-center": true, "cursor-pointer group": handleClick, "px-4": true})} onClick={() => handleClick()}>
    <div className="hidden mr-1 sm:block">{icon}</div>

    <div>
      <h3 className="text-indigo-600 text-md dark:text-foreground">{title}</h3>
      {meta && <p className="text-sm text-gray-500">{meta}</p>}
    </div>

    <div className="flex items-center ml-auto">
      <Chip
        classNames={{
          base: "mx-3 px-3",
          content: "text-sm text-white font-semibold",
        }}
        color={status}
        size="sm"
      >
        {required ? "Required" : "Optional"}
      </Chip>

      {status === "danger" && <XCircleIcon className="w-10 h-10 mr-2 text-danger" aria-hidden="true" />}
      {status === "success" && <CheckCircleIcon className="w-10 h-10 mr-2 text-success" aria-hidden="true" />}
      {status === "warning" && <QuestionMarkCircleIcon className="w-10 h-10 mr-2 text-warning" aria-hidden="true" />}
      {status === "outstanding" && <ExclamationCircleIcon className="w-10 h-10 mr-2 text-info" aria-hidden="true" />}

      {!handleClick && <div className="mr-8" />}
      {handleClick && <ChevronRightIcon className="w-8 h-8 text-gray-300 group-hover:text-blue-500" aria-hidden="true" />}
    </div>
  </div>
)

CheckListItem.propTypes = {
  handleClick: PropTypes.func,
  icon: PropTypes.object.isRequired,
  meta: PropTypes.string,
  required: PropTypes.bool,
  status: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

export default CheckListItem
